import { axiosServices } from "./axiosServices";

export const adminServices = { getEmployeeCreation, createEmployee, changeUserSatus, createEmployeeBulk, uploadFile, updateEmployee, getProfileData, adminStepAssign, getAdminLogList, reIinviteEmployee, getPageByModule, getFieldConfig, updateFieldConfig, createFieldConfig, adminDashboardOB, adminDashboardBidding, adminDashboardP2P, getDelayAnalysisReport, updateDelayAnalysisReport, downloadDAR };

function getEmployeeCreation(param) {
  return axiosServices.getAxios(`/v1/admin/employees${param}`).then((res) => {
    return res;
  });
}
function createEmployee(bodyData) {
  return axiosServices
    .postAxios(`/v1/admin/employees/`, bodyData)
    .then((res) => {
      return res;
    });
}

function createEmployeeBulk(bodyData) {
  return axiosServices
    .postAxios(`/v1/admin/employees/bulk`, bodyData)
    .then((res) => {
      return res;
    });
}

function changeUserSatus(bodyData) {
  return axiosServices
    .postAxios(`/v1/internal/users/activate-user`, bodyData)
    .then((res) => {
      return res;
    });
}

function uploadFile(bodyData, vId) {
  return axiosServices
    .putAxios(`/v1/common/users/${vId}`, bodyData)
    .then((res) => {
      return res;
    });
}

function updateEmployee(bodyData, eId) {
  return axiosServices
    .putAxios(`/v1/admin/employees/${eId}`, bodyData)
    .then((res) => {
      return res;
    });
}

function getProfileData(eId) {
  return axiosServices
    .getAxios(`/v1/common/users/profile?userId=${eId}`)
    .then((res) => {
      return res;
    });
}

function adminStepAssign(bodyData, stepId) {
  return axiosServices
    .postAxios(`/v1/admin/steps/${stepId}/update-assignee`, bodyData)
    .then((res) => {
      return res;
    });
}

function getAdminLogList(param) {
  return axiosServices
    .getAxios(`/v1/admin/api-logs/${param}`)
    .then((res) => {
      return res;
    });
}

function reIinviteEmployee(bodyData) {
  return axiosServices
    .postAxios("/v1/admin/employees/reinvite", bodyData)
    .then((res) => {
      return res;
    });
}

function adminDashboardOB(bodyData) {
  return axiosServices
    .postAxios("/v1/internal/dashboard/onboarding", bodyData)
    .then((res) => {
      return res;
    });
}

function getPageByModule(param) {
  return axiosServices
    .getAxios(`/v1/admin/field-configs/pages${param}`)
    .then((res) => {
      return res;
    });
}

function adminDashboardBidding(bodyData) {
  return axiosServices
    .postAxios("/v1/internal/dashboard/bidding", bodyData)
    .then((res) => {
      return res;
    });
}

function adminDashboardP2P(bodyData) {
  return axiosServices
    .postAxios("/v1/internal/dashboard/p2p", bodyData)
    .then((res) => {
      return res;
    });
}

function getFieldConfig(param) {
  return axiosServices
    .getAxios(`/v1/admin/field-configs${param}`)
    .then((res) => {
      return res;
    });
}


function updateFieldConfig(bodyData, eId) {
  return axiosServices
    .putAxios(`/v1/admin/field-configs/${eId}`, bodyData)
    .then((res) => {
      return res;
    });
}

function createFieldConfig(bodyData) {
  return axiosServices
    .postAxios("/v1/admin/field-configs", bodyData)
    .then((res) => {
      return res;
    });
}


function getDelayAnalysisReport(param) {
  return axiosServices
    .getAxios(`/v1/internal/analysis-report${param}`)
    .then((res) => {
      return res;
    });
}

function updateDelayAnalysisReport(bodyData, eId) {
  return axiosServices
    .patchAxios(`/v1/internal/analysis-report`, bodyData)
    .then((res) => {
      return res;
    });
}

function downloadDAR(bodyData) {
  return axiosServices
    .postAxios("/v1/internal/analysis-report/download", bodyData)
    .then((res) => {
      return res;
    });
}